import { useCallback } from 'react';
import { useAuthStore } from '@/stores/authStore';
/** Whether a site belongs in this user's pickers (0055): every site they
 *  may see, and a branch user's current branch only. Names of other sites
 *  stay readable for history. */
export function useSiteFilter(): (siteId: string) => boolean {
  const access = useAuthStore((s) => s.access);
  useAuthStore((s) => s.selectedBranch);
  const isBranch = useAuthStore((s) => !!s.profile?.home_site_id);
  const current = useAuthStore.getState().branchId();
  return useCallback((siteId: string) => {
    if (isBranch) return siteId === current;
    return !access || access.all_sites || access.sites.includes(siteId);
  }, [access, isBranch, current]);
}
